import React from 'react';
import { ArrayField } from 'react-hook-form';
import { ATMTable, ATMField, ATMForm, ATMButton } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { INewFireDispatchMethods } from '../../../../../../../models/fire-fighting-dispatch.model';

interface IProps extends INewFireDispatchMethods {
  item: Partial<ArrayField>;
  index: number;
  showRemove: boolean;
  removeRow: (index: number) => void;
  onLitersChange: (value: string, inx: number) => void;
  onGallonsChange: (value: string, inx: number) => void;
}

const FlightInformationAirDropsCell: React.FC<IProps> = ({
  control,
  index,
  item,
  showRemove,
  removeRow,
  onLitersChange,
  onGallonsChange,
}) => {
  return (
    <ATMTable.Row>
      <ATMTable.Cell>
        <ATMField
          as={ATMForm.Input}
          name={`DispatchDrops[${index}].dipCount`}
          type="number"
          defaultValue={item.dipCount}
          placeholder={Lang.LBL_ENTER}
          control={control}
        />
      </ATMTable.Cell>
      <ATMTable.Cell>
        <ATMField
          as={ATMForm.Input}
          name={`DispatchDrops[${index}].dropCount`}
          type="number"
          defaultValue={item.dropCount}
          placeholder={Lang.LBL_ENTER}
          control={control}
        />
      </ATMTable.Cell>
      <ATMTable.Cell>
        <ATMField
          as={ATMForm.Input}
          name={`DispatchDrops[${index}].waterLiters`}
          type="number"
          defaultValue={item.waterLiters}
          control={control}
          placeholder={Lang.LBL_ENTER}
          onChange={([_, { value }]) => {
            onLitersChange(value, index);
            return value;
          }}
        />
      </ATMTable.Cell>
      <ATMTable.Cell>
        <ATMField
          as={ATMForm.Input}
          name={`DispatchDrops[${index}].waterGallons`}
          type="number"
          defaultValue={item.waterGallons}
          placeholder={Lang.LBL_ENTER}
          control={control}
          onChange={([_, { value }]) => {
            onGallonsChange(value, index);
            return value;
          }}
        />
      </ATMTable.Cell>
      {showRemove && (
        <ATMTable.Cell textAlign="center">
          <ATMButton
            icon="trash alternate outline"
            onClick={() => removeRow(index)}
          />
        </ATMTable.Cell>
      )}
    </ATMTable.Row>
  );
};

export default FlightInformationAirDropsCell;
